import React from 'react';

import Grid from '@material-ui/core/Grid';
import MuiAlert from '@material-ui/lab/Alert';

//Others
import { withStyles } from '@material-ui/core/styles';
import { Component } from 'react';
import { compose } from 'recompose';
import MaterialTable from 'material-table'

//Components
import LoadingBackdrop from '../../public/components/LoadingBackdrop';

import * as apiConstants from '../../../../constants/apiConstants';

//Others
const axios = require('axios').default;
const FormData = require('form-data');
const api_base_url = "https://e-learning-be-ybcs6wa7da-as.a.run.app";

const useStyles = theme => ({
    root: {
        margin: 15,
        marginTop: 50
    }
});

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class AssignedWorks extends Component {
    constructor() {
        super()
        this.state = {
            testsToShow: [],
            isLoading: false
        };
    }

    componentDidMount = async () => {
        this.setState({
            isLoading: true
        });

        await this.handleGetAllSubmittedTests();

        this.setState({
            isLoading: false
        });
    }

    handleGetAllSubmittedTests = async () => {
        try {
            const testsToShow = [];
            const res = await axios({
                method: 'get',
                url: `${apiConstants.UTEST_AVENUE_API}/tests/submitted`
                // url: 'https://chatter-funky-busby.glitch.me/tests'
            });

            const resData = res.data;
            await resData.tests.map((test) => {
                testsToShow.push({
                    testCategory: test.testCategory,
                    testType: test.testType,
                    status: test.teacherFile === 'Unassigned' ? 'Waiting' : 'Checked',
                    assignTo: test.assignTo,
                    createdAt: new Date(test.createdAt).toDateString()
                })
            });

            this.setState({
                testsToShow: testsToShow
            });

        } catch (err) {
            console.log(err);
        }
    }

    render() {
        const { classes } = this.props;

        return (
            <Grid item xs={12}>
                <LoadingBackdrop isLoading={this.state.isLoading} />
                <MaterialTable
                    data={this.state.testsToShow}
                    columns={[
                        {
                            title: 'Category',
                            field: 'testCategory',
                            editable: 'never'
                        },
                        {
                            title: 'Type',
                            field: 'testType',
                            editable: 'never'
                        },
                        {
                            title: 'Assign to',
                            field: 'assignTo',
                            editable: 'never'
                        },
                        {
                            title: 'Created',
                            field: 'createdAt',
                            editable: 'never',
                            defaultSort: 'desc',
                            customSort: (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
                        },
                        {
                            title: 'Status',
                            field: 'status',
                            editable: 'never'
                        }
                    ]}
                    options={{
                        actionsColumnIndex: -1,
                        exportAllData: true,
                        exportButton: true,
                        grouping: true,
                        pageSize: 10
                    }}
                    title='All assigned test'
                />
            </Grid>
        )
    }
}
export default compose(
    withStyles(useStyles)
)(AssignedWorks);